import styled from '@mui/material/styles/styled'
import Stack from '@mui/material/Stack'
export const EditMatchedLocationHeaderContainer = styled(Stack, {
  name: 'Container',
  slot: 'Root',
  skipSx: true,
})`
  color: #005aa3;
  padding: 14px 20px;
  background-color: #e6f3fa;
  line-height: 24px;
  margin: 0;
  vertical-align: middle;
  border-top: solid 1px #ddd;
  width: 100%;
  align-items: center;
`
